import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { DealerChassisResultsRoute } from "../../../navigation/DealerRoutes";
import { useRouteParams } from "../../../navigation/useRouteParams";
import { useSearchForm } from "../../../stores/hooks/useSearchForm";
import { Input } from "../../../ui/Input/Input";
import { CarIcon } from "../../../ui/icons/CarIcon";

export const ChassisInput: FunctionComponent = () => {
  const { t } = useTranslation();
  const params = useRouteParams(DealerChassisResultsRoute);
  const [{ vehicleChassis }, { setVehicleChassis: setChassis }] =
    useSearchForm();

  return (
    <Input
      onChange={(event): void => {
        setChassis(event.target.value);
      }}
      aria-label="selectedChassis"
      before={<CarIcon />}
      defaultValue={vehicleChassis || params?.vehicleChassis}
      name="vehicleChassis"
      placeholder={t("searchForm.vehicleChassisPlaceholder")}
    />
  );
};
